/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import { agenceService } from "../views/service/agence.service";
import Vue from "vue";
import _ from "lodash";

const state = {
  agences: [],
  agence: {},
  loading: false
};
const getters = {
  getAgences: state => state.agences,
  getAgence: state => state.agence,
  getLoading: state => state.loading
};
const actions = {
  lookupAgencesAction({ commit }, { pagedFilter, showLoader }) {
    agenceService.allUserAgencesList(pagedFilter, showLoader).then(res => {
      commit("agencesMutation", res);
    });
  },
  changeActivation({ commit, dispatch }, { id, isEnabled, pagedFilter }) {
    agenceService
      .changeActivation({ id, isEnabled })
      .then(res => {
        dispatch("lookupAgencesAction", { pagedFilter, showLoader: false });
      })
      .catch(error => {
        Vue.$log.error(error);
      });
  },
  getAgenceByIdAction({ commit }, id) {
    agenceService.fetchAgenceById(id).then(
      result => {
        commit("setAgence", result);
      },
      error => {
        console.log(error);
      }
    );
  }
};
const mutations = {
  agencesMutation: (state, agences) => {
    state.agences = agences;
    state.agences.content = _.map(agences.content, function(element) {
      return _.extend({}, element, { shouldLoading: false });
    });
  },
  setAgence(state, val) {
    state.agence = val;
  },

  setLoading(state, isLoading) {
    state.loading = isLoading;
  },

  setShouldLoading(state, val) {
    state.agences.content.forEach(agence => {
      if (agence.id === val) {
        agence.shouldLoading = true;
      }
    });
  },
  setShouldNotLoading(state, val) {
    state.agences.content.forEach(agence => {
      if (agence.id === val) {
        agence.shouldLoading = false;
      }
    });
  }
};

export const agence = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
